/**
 * Loading indicator.
 *
 * `label` is not decoration - on a till, a spinner with no words leaves the
 * cashier unsure whether the system is working or hung, and the queue behind
 * them makes that a real cost.
 */

const SIZES = {
    sm: 'h-4 w-4 border-2',
    md: 'h-6 w-6 border-2',
    lg: 'h-10 w-10 border-[3px]'
};

const Spinner = ({ size = 'md', label = null, className = '' }) => (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
        <div
            className={`${SIZES[size] || SIZES.md} animate-spin rounded-full border-slate-300 border-t-brand-600`}
            role="status"
            aria-label={label || 'Loading'}
        />
        {label && <p className="text-sm text-slate-500">{label}</p>}
    </div>
);

/** Fills its container - for a panel that is still loading. */
export const SpinnerBlock = ({ label = 'Loading…' }) => (
    <div className="flex h-full min-h-[200px] w-full items-center justify-center">
        <Spinner size="lg" label={label} />
    </div>
);

export default Spinner;
